import React, { useState } from 'react';
import CircleChat from './CircleChat';

// サークル/イベント詳細ページに置くランチャー。
// - オーナー/スタッフ: 「魅力を教える」+「聞く」の2ボタンを並べて表示
// - その他のユーザー (ログイン済 or 未ログイン): 「聞く」1ボタンのみ
// 会話永続化により、externalIdは CircleChat 側で履歴取得APIから復元されるため、
// ここでは mode のみを保持する。
export default function ChatLauncher({
  scopeType, // 'circle' | 'event'
  scopeId, // number
  canManage = false,
  captchaToken = null,
}) {
  // modalState: null | { mode: 'creator' | 'user' }
  const [modalState, setModalState] = useState(null);

  const creatorLabel =
    scopeType === 'circle'
      ? '✏️ サークルの魅力を教える'
      : '✏️ イベントの魅力を教える';
  const userLabel =
    scopeType === 'circle'
      ? '💬 このサークルについて聞く'
      : '💬 このイベントについて聞く';

  const openModal = (mode) => {
    setModalState({ mode });
  };

  const closeModal = () => setModalState(null);

  const templateType = modalState
    ? `${scopeType}_knowledge_${modalState.mode}`
    : null;

  return (
    <>
      {canManage ? (
        <div className="cchat-launcher-group">
          <button
            type="button"
            className="cchat-launcher-btn cchat-launcher-btn-primary"
            onClick={() => openModal('creator')}
          >
            {creatorLabel}
          </button>
          <button
            type="button"
            className="cchat-launcher-btn cchat-launcher-btn-secondary"
            onClick={() => openModal('user')}
          >
            {userLabel}
          </button>
        </div>
      ) : (
        <button
          type="button"
          className="cchat-launcher-btn"
          onClick={() => openModal('user')}
        >
          {userLabel}
        </button>
      )}
      {modalState && (
        <CircleChat
          templateType={templateType}
          scopeType={scopeType}
          scopeId={scopeId}
          canManage={modalState.mode === 'creator'}
          captchaToken={captchaToken}
          onClose={closeModal}
        />
      )}
    </>
  );
}
